import CrudRequest from '@rootCommon/services/crud-request';
import { BRANDING_FILE } from '@rootCommon/constants/end-points';
import { ADMIN } from '@rootCommon/constants/common';
import { BrandingFile, BrandingFileDto } from '@rootCommon/types/branding';

const BRANDING_FILE_ADMIN = `${BRANDING_FILE}/${ADMIN}`;
const BRANDING_FILES_ADMIN = `${BRANDING_FILE}/all/${ADMIN}`;

class BrandingFileService extends CrudRequest<BrandingFile, BrandingFileDto> {
  constructor() {
    super(BRANDING_FILE_ADMIN);
  }

  getList = async (): Promise<BrandingFile[]> => {
    const res = await CrudRequest.get<BrandingFile[]>(BRANDING_FILES_ADMIN);

    return res.data;
  };
}

export default new BrandingFileService();
